// extracted by mini-css-extract-plugin
export default {"scan":"FilledSmallBtn_scan__Y0Ly6","qr":"FilledSmallBtn_qr__3APkG"};